import { apiInstance, gql } from "@/services/httpAdapter";

async function getLoginUser(tenantId, userId) {
	const query = gql`
		query getUser($_id: String!, $locationId: String!) {
			getUser(_id: $_id, locationId: $locationId) {
				_id
				locationId
				preferences {
					landingPage
					landingLocation
				}
			}
		}
	`;

	const variables = {
		locationId: tenantId,
		_id: userId,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.getUser;
	} catch (err) {
		console.error(err);
		return null;
	}
}

async function login(locationId, username) {
	const query = gql`
		query login($locationId: String!, $username: String!, $password: String!) {
			login(locationId: $locationId, password: $password, username: $username) {
				_id
				username
				fullName
				position
				locationId
				employeeId
				supervisor {
					_id
					fullName
				}
				communications {
					acceptsTxt
					communicationType
					usage
					value
				}
				preferences {
					landingPage
					landingLocation
				}
				profilePicture
				actions
				isAppBlockedBy {
					role
					url
					assignedBy
				}
				currentPayPlanAssignment {
					assignedBy
					planId {
						_id
						name
						position
					}
				}
				upcomingPayPlanAssignment {
					assignedBy
					planId {
						_id
						name
						position
					}
					acknowledgementStatus {
						status
					}
					embeddedSigningLinks {
						url
						role
					}
				}
				dashboardLayout {
					w
					h
					x
					y
					i
					moved
					static
					isResizable
				}
			}
		}
	`;

	const variables = {
		locationId,
		username,
		password: "",
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.login;
	} catch (err) {
		console.error(err);
		return null;
	}
}

async function checkUserBlockStatus(locationId, username) {
	const query = gql`
		query checkUserBlockStatus($locationId: String!, $username: String!) {
			checkUserBlockStatus(locationId: $locationId, username: $username) {
				role
				url
				assignedBy
			}
		}
	`;

	const variables = {
		locationId,
		username,
	};

	try {
		const response = await apiInstance.post("/graphql", { query, variables });
		return response.data.data?.checkUserBlockStatus;
	} catch (err) {
		throw new Error(err);
	}
}

export { getLoginUser, login, checkUserBlockStatus };
